import React, { useState } from "react";
import { Select, ConfigProvider } from "antd";
import { DownOutlined } from "@ant-design/icons";
import useThemeStore from "(store)/themeStore";
import "styles/Select.css";

const SimpleSelectField = ({
  options = [],
  placeholder = "Please select",
  disabled = false,
  onChange,
  defaultValue,
  value,
}) => {
  const theme = useThemeStore((state) => state.theme);
  const [isFocused, setIsFocused] = useState(false);

  const customStyle = {
    border: isFocused
      ? "1px solid #1996A6"
      : theme === "dark"
      ? "1px solid #1f2937"
      : "1px solid #d9d9d9",
    borderRadius: "8px",
    overflow: "hidden",
  };

  const customArrow = <DownOutlined style={{ color: "gray" }} />;

  const handleSelectChange = (value) => {
    if (onChange) onChange(value);
  };

  return (
    <div className="w-full flex items-center justify-stretch">
      <ConfigProvider
        theme={{
          components: {
            Select: {
              optionActiveBg: theme === "dark" ? "#4b5563" : "#f5f5f5",
              optionSelectedBg: theme === "dark" ? "#FAB54E" : "#1996A6",
              optionSelectedColor: "#fff",
              colorText: theme === "light" ? "black" : "white",
              colorTextPlaceholder: "gray",
              optionActiveColor: "#fdfdfd",
            },
          },
        }}
      >
        <Select
          onChange={handleSelectChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          style={{
            width: "100%",
            ...customStyle,
            height: "40px",
            position: "relative",
            boxShadow: "none",
          }}
          className="simple-select"
          placeholder={placeholder}
          optionFilterProp="label"
          options={options}
          disabled={disabled}
          suffixIcon={customArrow}
          defaultValue={defaultValue}
        />
      </ConfigProvider>
    </div>
  );
};

export default SimpleSelectField;
